<template>
    <div class="py-4 mb-3">
        <div class="text-dark-75 text-center"><span class="text-muted font-weight-bold">© 2026 </span> Kema. All rights reserved.</div>
    </div>
</template>

<script>
export default {
    name: "Footer"
};
</script>
